import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation updateResult(
      $id: Int!,
      $reportId: Int,
      $indicatorId: Int,
      $successCriteria: String,
      $classification: String,
      $description: String,
      $forecastInitial: Float,
      $forecastCurrent: Float,
      $relevant: Boolean,
  ) {
    updateResult(
      id: $id,
      reportId: $reportId,
      indicatorId: $indicatorId,
      successCriteria: $successCriteria,
      classification: $classification,
      description: $description,
      forecastInitial: $forecastInitial,
      forecastCurrent: $forecastCurrent,
      relevant: $relevant,
  ) {
      id
      success
    }
  }
`;

export function useUpdateResult() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };
  return { data, isLoading, run };
}

